import { render, staticRenderFns } from "./PointCost.vue?vue&type=template&id=6166c566&lang=pug&"
import script from "./PointCost.vue?vue&type=script&lang=js&"
export * from "./PointCost.vue?vue&type=script&lang=js&"
import style0 from "./PointCost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports